export default __webpack_public_path__ + "static/portfolio-3-eeab2dcdaff7048b804db0800f33c51d.jpg";